import { view } from "@risingstack/react-easy-state";
import useLoginRequired from "../../common/hooks/useLoginRequired";
import NotLoggedIn from "../../components/NotLoggedIn";
import PowerBIReport from "../../components/PowerBIReport";
import authStore from "../../stores/auth/authStore";

/**
 * Page for showing the "Årets Matglede" campaign report.
 */
const JoyOfFoodCampaignPage = () => {
   useLoginRequired("SEGMENTED_CONTENT");

   if (!authStore.isLoggedIn()) {
      return <NotLoggedIn />;
   }

   if (authStore.getCurrentCompany()?.customerGroup.startsWith("010|")) {
      return (
         <div>
            <h2>Årets Matglede</h2>
            <p>Her vil det i løpet av uken komme oversikten over dine tall i forbindelse med Årets Matglede. Følg med!</p>
         </div>
      );
   }

   const reportName = authStore.getCurrentCompany()?.customerGroup.startsWith("010|")
      ? "aretsmatglede_dagligvare"
      : "aretsmatglede";

   return (
      <PowerBIReport
         reportName={reportName}
         title={`Utvikling for ${authStore.getCurrentCompany()?.name}`}
         mobileHeightRatio={4}
      />
   );
};

export default view(JoyOfFoodCampaignPage);
